export const SEED_POSITIONS = [
  {
    id: 'seed-pos-1',
    name: 'Front Counter',
    category: 'FOH',
    description: 'Taking orders and serving guests at the front counter',
    sortOrder: 1,
    requiredShifts: 3,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'seed-pos-2',
    name: 'Drive Thru Order',
    category: 'Drive Thru',
    description: 'Taking orders at the drive thru speaker',
    sortOrder: 2,
    requiredShifts: 3,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'seed-pos-3',
    name: 'Drive Thru Window',
    category: 'Drive Thru',
    description: 'Handling payment and serving guests at the window',
    sortOrder: 3,
    requiredShifts: 3,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'seed-pos-4',
    name: 'Beverages',
    category: 'FOH',
    description: 'Preparing drinks, milkshakes, and lemonade',
    sortOrder: 4,
    requiredShifts: 3,
    createdAt: new Date().toISOString(),
  },
];
